import React from "react";
import { bigLogo } from "../../Assets";

const NotFoundPage = () => {
  return (
    <div className="wrapper error_container">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="not-found-menu">
              <figure>
                <img src={bigLogo} />
              </figure>
              <h1>404 Not Found</h1>
              <div className="error-details">
                Sorry, an error has occured, Requested page not found!
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
